export const CardShimmer = () => (
    <div className="grid animate-pulse custom-bg-grey-50 h-[158px] rounded-md max-w-[300px] lg:w-[300px] w-full"></div>
  );
  
  export const WidgetCardShimmer = () => (
    <div className="grid gap-8 lg:grid-flow-col content-center">
      <CardShimmer />
    </div>
  );
  
  export const TiledCardShimmer = () => (
    <div className="grid gap-8 lg:justify-start items-stretch content-stretch">
      <div className="grid gap-8 lg:grid-flow-col content-center">
        <CardShimmer />
        <CardShimmer />
      </div>
    </div>
  );
  
  export const FullTableShimmer = () => (
    <span className="grid custom-bg-grey-50 animate-pulse rounded-lg h-[40vh] w-full mb-4"></span>
  );
  
  export const InLineTableShimmer = ({ length, fullWidth }) => (
    <div className={`flex gap-[4px] ${(length === 1 || fullWidth) ? 'w-full': 'w-[calc(100%-80px)]'}`}>
      {Array.from({ length }).map((_, index) => (
        <span key={index} className="grid custom-bg-grey-50 animate-pulse rounded-lg h-[34px] w-full"></span>
      ))}
    </div>
  );
  export const FileUploadShimmer = ({ height='56px' }) => (
    <div className={`grid animate-pulse custom-bg-grey-50 rounded-lg h-[${height}] w-full`}></div>
  )
  
  export const InputShimmer = ({ width }) => (
    <div
      className={`grid animate-pulse rounded-lg p-4 h-12 custom-bg-grey-50 w-[${
        width ? width : "310px"
      }]`}
    ></div>
  );
  
  export const PayrollTitleShimmer = () => (
    <span className="animate-pulse custom-bg-grey-50 rounded-lg h-[40px] w-[200px]"></span>
  );

  export const SidebarShimmer = ({className}) => (
    <span className={`animate-pulse custom-bg-grey-50 rounded-lg h-[131px] w-full ${className}`}></span>
  )
  export const IconShimmer = () => {
      <div className="relative overflow-hidden">
        <div className="w-[18px] h-[18px] custom-bg-grey-50 rounded animate-pulse" />
      </div>
  };

  export const BoardHeaderShimmer = () => (
    <div className="flex items-center justify-between custom-bg-white-200 
      rounded-[4px] px-[16px] py-[8px] w-[285px] h-[40px] gap-3 ">

      <div className="w-[50px] h-[24px] rounded-[4px] animate-pulse custom-bg-grey-50" />

      <div className="flex items-center gap-2">
        <div className="h-[18px] w-[24px] rounded-[12px] animate-pulse custom-bg-grey-50" />
        <div className="h-1.5 w-[16px] rounded animate-pulse custom-bg-grey-50" />
      </div>

    </div>
  );
  